<template>
  <v-main>
    <Cart/>
  </v-main>
</template>

<script>

import Cart from '@/views/components/Cart.vue'

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    Cart
  }
}
</script>
